/* eslint-disable react/jsx-no-target-blank */
import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";

function SubscribeModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 20000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <Modal
      className="!top-[32%] !w-[300px] subscribe_modal"
      title="Basic Modal"
      open={isModalOpen}
      footer={false}
    >
      <div className="text-2xl text-white float-right !mt-[-20px] !mr-[-10px] cursor-pointer">
        <CloseOutlined onClick={() => handleCancel()} />
      </div>
      <br />
      <div className="flex items-center justify-center flex-col">
        <div className="text-[white] text-[20px] mb-[20px] text-center">
          Learn More About How We Can Help You
        </div>
        <div className="flex flex-col items-center">
          <img src="/assets/meta.png" alt="logo" />
        </div>
        <div className="text-[white] text-[14px] my-[20px]">
          Schedule a Meeting?
        </div>
        <div>
          <a
            href="https://calendly.com/razametaworldx/30min"
            className="!font-bold"
            target="_blank"
          >
            <Button
              onClick={() => handleCancel()}
              type="primary"
              className="!font-bold"
            >
              BOOK A DEMO
            </Button>
          </a>
        </div>
      </div>
    </Modal>
  );
}

export default SubscribeModal;
